'use strict';

var DuplicatedValidationDirective = function DuplicatedValidationDirective() {
  return {
    restrict: 'A',
    require: '^ngModel',
    scope: {
      existing: '='
    },
    link: function link(scope, element, attr, ngModel) {
      var existing = scope.existing;
      ngModel.$parsers.unshift(function (value) {
        var valid = existing.indexOf(value) === -1;
        ngModel.$setValidity('duplicated', valid);
        return value;
      });
    }
  };
};
DuplicatedValidationDirective.$inject = [];
module.exports = DuplicatedValidationDirective;